export const siteSettings = {
  name: "Axion Zone",
  link: "https://axionzone.com",
  email: "support@axionzone.com",
  appLink: "https://app.axionzone.com",
};
